module.exports = __webpack_public_path__ + "img/guide.ac78ac39.gif";